import { render, staticRenderFns } from "./Membership.vue?vue&type=template&id=5d5c2189&scoped=true"
import script from "./Membership.vue?vue&type=script&lang=ts"
export * from "./Membership.vue?vue&type=script&lang=ts"
import style0 from "./Membership.vue?vue&type=style&index=0&id=5d5c2189&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d5c2189",
  null
  
)

export default component.exports